export const POOL_ITEMS = [
  { key: 'banker', label: '庄', className: 'banker' },
  { key: 'player', label: '闲', className: 'player' },
  { key: 'tie', label: '和', className: 'tie' },
  { key: 'bankerPair', label: '庄对', className: 'banker-pair' },
  { key: 'playerPair', label: '闲对', className: 'player-pair' }
];

export function normalizePoolValues(pool = {}) {
  return POOL_ITEMS.map(({ key }) => Math.max(0, Math.floor(Number(pool?.[key]) || 0)));
}

export function poolTweenDuration(from, to) {
  const difference = Math.abs((Number(to) || 0) - (Number(from) || 0));
  return Math.min(850, 350 + Math.log10(Math.max(1, difference)) * 200);
}

export function poolBarRatios(values = []) {
  const safe = Array.from({ length: 5 }, (_, index) => Math.max(0, Number(values[index]) || 0));
  const maximum = Math.max(1, ...safe);
  return safe.map((value) => value / maximum);
}

export const POOL_SURGE_WINDOW_MS = 2200;
export const POOL_SURGE_MIN_UPDATES = 3;
export const POOL_SURGE_LEAD_RATIO = 1.18;

export function createPoolSurgeMomentum() {
  return Array.from({ length: 5 }, () => []);
}

export function detectPoolSurge(momentum, previousValues, nextValues, now = Date.now()) {
  const histories = Array.from({ length: 5 }, (_, index) => Array.isArray(momentum?.[index]) ? [...momentum[index]] : []);
  const previous = Array.from({ length: 5 }, (_, index) => Math.max(0, Number(previousValues?.[index]) || 0));
  const next = Array.from({ length: 5 }, (_, index) => Math.max(0, Number(nextValues?.[index]) || 0));
  histories.forEach((events, index) => {
    const delta = next[index] - previous[index];
    if (delta < 0) events.splice(0, events.length);
    else if (delta > 0) events.push({ at: Number(now) || 0, delta });
    const cutoff = (Number(now) || 0) - POOL_SURGE_WINDOW_MS;
    while (events[0]?.at < cutoff) events.shift();
  });
  const ordered = next.map((value, index) => ({ value, index })).sort((a, b) => b.value - a.value);
  const leader = ordered[0];
  const runnerUp = ordered[1]?.value || 0;
  const events = histories[leader.index];
  const cumulativeGrowth = events.reduce((sum, event) => sum + event.delta, 0);
  const minimumGrowth = Math.max(100, leader.value * .002);
  const leadRatio = leader.value / Math.max(1, runnerUp);
  const surging = events.length >= POOL_SURGE_MIN_UPDATES
    && cumulativeGrowth >= minimumGrowth
    && leadRatio >= POOL_SURGE_LEAD_RATIO;
  const intensity = surging
    ? Math.min(1, ((events.length - POOL_SURGE_MIN_UPDATES + 1) * .22) + ((leadRatio - POOL_SURGE_LEAD_RATIO) * 1.2))
    : 0;
  return { momentum: histories, surgeIndex: surging ? leader.index : -1, intensity, leadRatio, cumulativeGrowth };
}
